






























































import { Vue, Component } from 'vue-property-decorator';
import { getDetail, getLimitInfo } from '../api';
import VoteButton from '../components/VoteButtonNew.vue';
import XGplay from '@/components/XGplayer.vue';
import { isWeiXin } from '@/common/ts/common';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
Vue.use(Swipe)
  .use(ImagePreview)
  .use(SwipeItem)
  .use(Lazyload);
@Component({
  components: {
    VoteButton,
    XGplay,
  },
})
export default class WorksDetail extends Vue {
  voteName: string = '2023project/q3/2023photography';
  id: string | number = '';
  obj: any = {};
  cover: any = [];
  time: boolean = false;
  enabletype: string = '0';
  showimg: boolean = false;
  limitVote: number = 0;
  unionId: string | null = '';
  isshow: boolean = false;
  async mounted() {
    const res = await getDetail(this.$route.query.id);
    this.obj = res.data;
    this.cover = res.data.cover;
    const now = new Date().getTime();
    this.enabletype = this.$route.query.enable + '';
    const baseInfo = await getLimitInfo();
    const time1 = parseInt(baseInfo.data.startTime) * 1000;
    const time2 = parseInt(baseInfo.data.endTime) * 1000;
    if (now < time2 && now > time1) {
      this.time = true;
    }
    this.limitVote = parseInt(baseInfo.data.limitvote);
    setTimeout(() => {
      this.isshow = true;
    }, 500);
  }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }
  votSuccess(data: any, index: any, votesInfo: any) {
    this.obj.votes = data;
    if (votesInfo + '' === '3') {
      this.showimg = true;
    }
  }
  gettocket() {
    window.location.href =
      'https://rris.ccb.com/app/#/promotePage?promoteCode=58953808&userType=1&utm_source=app&utm_campaign=app';
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
